// extracted by mini-css-extract-plugin
export default {"wrapper":"vqRlD5IbTMq3Rq5SHdOn","storeSelector":"pW_cpTuKhIjdAhQ8lzvr"};